import { Platform } from 'react-native';

import ExpoApplePay, { type EventSubscription } from './src/ExpoApplePayModule';

export async function canMakePayments(paymentOptions: { networks: string[] }): Promise<{
  available?: boolean;
  hasCards?: boolean;
}> {
  return (
    ExpoApplePay?.canMakePayments(paymentOptions) ??
    Promise.reject(new Error('Error initializing ExpoApplePay?.canMakePayments()'))
  );
}

enum Events {
  PaymentAuthorization = 'PaymentAuthorization', // Event sent on completion of payment authorization
  PaymentAuthorizationClosed = 'PaymentAuthorizationClosed', //Event sent on paymentAuthorizationViewControllerDidFinish
}

export function addPaymentAuthorizationListener(
  listener: (params: {
    data: {
      paymentData: string;
      billingInformation: string;
      paymentType: string;
      displayName: string;
      customerFamilyName: string;
      customerGivenName: string;
      customerNickname: string;
    };
  }) => void
): EventSubscription {
  if (ExpoApplePay) {
    return ExpoApplePay.addListener(Events.PaymentAuthorization, listener);
  }

  // noop Subscription
  return {
    remove() {},
  };
}

export function addPaymentAuthorizationClosedListener(listener: () => void): EventSubscription {
  if (ExpoApplePay) {
    return ExpoApplePay.addListener(Events.PaymentAuthorizationClosed, listener);
  }

  // noop Subscription
  return {
    remove() {},
  };
}

/**
 * Before calling this, the function `canMakePayments()`must be invoked.
 * Failing to do so will result in payment request failing due to mussing supported card networks
 */
export async function makePaymentRequest(paymentDetails: {
  cartLabels?: string[];
  cartPrices?: number[];
  countryCode: string;
  currencyCode: string;
  itemLabel: string;
  merchantId: string;
  payeeName: string;
  total: number;
}) {
  return ExpoApplePay?.makePaymentRequest(paymentDetails) ?? Promise.reject();
}

export function isSupported() {
  return Platform.OS === 'ios';
}
